import React, { useMemo } from 'react';
import useIntls from '@opm/hooks/useIntls';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import type { TGameMap } from '@opm/pages/CompetitorAdComparison/hooks/useGameMap';
import { ITrendItemBase } from '../../types';
import './TrendTopicCell.scss';
import TextBubbles from '@home/components/TextBubbles';
import TrendTopicTags from '../../components/TrendTopicTags';
import { TTopicTypeColorMap } from '../../utils';
import { useGameMeta } from '../../components/useGameMeta';

interface ITrendTopicCellProps {
  record: ITrendItemBase;
  /** 游戏元信息字典（cond.materials_config_games）：id → meta */
  gameMap?: TGameMap;
  onTitleClick?: (record: ITrendItemBase) => void;
  topicTypeColorMap?: TTopicTypeColorMap;
}

/**
 * Trend Topic 列单元格：标题（可点击跳详情）+ 一级/二级类目 Chips
 *
 * Topic Type 颜色：
 *  - L1 类目 → 来自 cond 颜色映射
 *  - L2 类目 → 固定灰色（带 hover tooltip）
 */
export default function TrendTopicCell({
  record,
  gameMap,
  topicTypeColorMap,
  onTitleClick,
}: ITrendTopicCellProps) {
  const { isEn } = useIntls();
  // topic：后端按多语言下发 topic（zh）/ topic_en（en），按当前语言取值
  const title = useMemo(
    () => (isEn ? record?.topic_en || record?.topic : record?.topic),
    [isEn, record?.topic_en, record?.topic],
  );

  const { gameName, gameLogo } = useGameMeta(record, gameMap);

  return (
    <div className="dbom-ct-topic-cell">
      <span className="dbom-ct-topic-cell__title-wrapper" onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onTitleClick?.(record);
      }}>
        <TextBubbles
          className="dbom-ct-topic-cell__title"
          text={title}
        />
      </span>
      {gameName && (
        <div className="dbom-ct-topic-cell__game" title={gameName}>
          <RenderGameIcon
            className="dbom-ct-topic-cell__game-logo"
            gameInfo={{
              cover: gameLogo,
              entity_type: (record as any)?.entity_type,
              edition_unified_id: record?.game_id,
            }}
          />
          <TextBubbles className="dbom-ct-topic-cell__game-name" text={gameName} />
        </div>
      )}
      <div className="dbom-ct-topic-cell__tags">
        <TrendTopicTags
          record={record}
          topicTypeColorMap={topicTypeColorMap}
          chipClassName="dbom-ct-topic-cell__chip"
        />
      </div>
    </div>
  );
}
